import moment from "moment";
import { encryptAES } from './CryptographyUtils'
import { getCodeSecurity } from './apiCanal'
import helpers from './helpers'

export const t = (text) => (text ? text : "");
export const getMonthYear = (date) =>
	moment(date, "DD/MM/YYYY")
		.locale("es")
		.format("MMM YYYY");

export const getDayMonth = (date) =>
	moment(date, "DD/MM/YYYY")
		.locale("es")
		.format("DD MMM");

export const getConvertDateToString = (date, inputFormat, outFormat) => {
	if (inputFormat) {
		return moment(date, inputFormat).format(outFormat);
	}
	return moment(date).format(outFormat);
};

export const formatToSelect = (list, filter) => {
	const [id, value] = Object.keys(filter);
	return list.map((item) => {
		return {
			[id]: item[`${filter[id]}`],
			[value]: item[`${filter[value]}`],
			...item,
		};
	});
};

export const formatToSelectCustom = (list, filter) => {
	const [value, text, label] = Object.keys(filter);
	return list.map((item) => {
		return {
			[value]: item[`${filter[value]}`],
			[text]: item[`${filter[text]}`],
			[label]: item[`${filter[label]}`],
			...item,
		};
	});
};

export const formatExactSelect = (array, filter) => {
	const [value, text] = Object.keys(filter);
	return array.map((item) => {
		return {
			[value]: item[`${filter[value]}`],
			[text]: item[`${filter[text]}`]
		};
	});
};

export const deleteDuplicateObject = (list, key) => {
	return [...new Map(list.map(item => [item[key], item])).values()];
};

export const isCotizar = () => {
	const regex = /^\/cotizar\/?/
	return regex.test(window.location.pathname)
};

export const formatAmountThousand = num => {
	const aux = num?.toString().split('.');
	if(aux!==undefined){
		return `${aux[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")}${aux[1] ? `.${aux[1]}` : ''}`
	}
};

export const getFormatMount = (mount, formatThousand = false) => {
	if(mount) {
		let value = mount;
		if(formatThousand) {
			value = formatAmountThousand(mount);
		}
		const newMount = value.split(".");
		return newMount[0];
	}
	return "";
};

export const getFormatDecimalMount = (mount, formatThousand = false) => {
	if(!mount){
		return "";
	}
	let value = mount;
	if(formatThousand) {
		value = formatAmountThousand(mount);
	}
	const newMount = value.split(".");
	if (newMount[1]) {
		if (newMount[1].length == 1) {
			return `${newMount[1]}0`;
		}
		return newMount[1];
	} else {
		return "00";
	}
};

export const decodeB64 = (text) => {
	return window.atob(text);
};

export const encodeB64 = (text) => {
	return window.btoa(text);
};

export const removeItemsArrayFromArray = (arrayBase, arrayToRemove, key) => {
	arrayToRemove.forEach((item) => {
		const index = arrayBase.findIndex(element => element[key] === item);
		if (index >= 0) {
			arrayBase.splice(index, 1);
		}
	});
	return arrayBase;
};

export const scrollToUp = (sectionId) => {
    const element = document.getElementById(sectionId);
	element && element.scrollIntoView({ behavior: "smooth" });
};

export const getMinLengthDocument = (typeDocument) => {
    switch (typeDocument) {
        case '1':
            return 11;
        case '2':
            return 8;
        case '4':
            return 9;
        default:
            return 8;
    }
};

export const getMaxLengthDocument = (typeDocument) => {
    switch (typeDocument) {
        case '1':
            return 11;
        case '2':
            return 8;
        case '4':
            return 11;
        default:
            return 8;
    }
};

export const addSpaceAfterNChar = (str, n) => {
	if (typeof str !== 'string') {
	  return str;
	}
	if (str.length <= n) {
	  return str;
	}
	return `${str.slice(0, n)} ${str.slice(n)}`;
};

export const transformCurrency = (str) => {
	if (typeof str !== 'string') {
	  return str;
	}
	return str.replace(/S\/|,/g, '').trim();
};

export const compareSumAssured = (currentValue, prevValue) => {
  const parseAmount = (str) => {
    if (typeof str !== 'string') return null;
    const num = Number(str.replace(/[^\d.-]/g, ''));
    return isNaN(num) ? null : num;
  };

  if (!currentValue?.text || !prevValue?.text) {
    return null;
  }

  const currentAmount = parseAmount(currentValue.text);
  const prevAmount = parseAmount(prevValue.text);

  if (currentAmount === null || prevAmount === null) {
    return null;
  }
  return currentAmount > prevAmount;
}

export const findDefaultObjectValue = (array) => {
  if (!Array.isArray(array)) {
    return null;
  }
  return array.find((item) => item.default === true) || null;
};

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const isYesNoValue = value => ['Si', 'No'].includes(value)

export const isNumberValue = text => /^-?\d+(\.\d+)?$/.test(text.trim())

export const encryptString = str =>
	encryptAES(
		helpers.convertToSafeString(str),
		getCodeSecurity()
	)

export function isElementHidden(el) {
  if (!el) return true;
  const style = window.getComputedStyle(el);
  return style.display === "none";
}

export const focusFirstErrorField = ({ getFieldState }) => {
	const fields = Array.from(document.querySelectorAll("input[name], select[name]"));
	const firstErrorEl = fields.find((el) => {
    const name = el.getAttribute("name");
		return name && getFieldState(name).error;
  });

	if (!firstErrorEl) return
	const target = isElementHidden(firstErrorEl) ? firstErrorEl.parentElement : firstErrorEl;
	target?.scrollIntoView({ behavior: 'smooth', block: 'center' })
}
